export default "/assets/images/mila-sock.25cd98aa2a82e54e.webp";